import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { HomeworksView } from '@/views/homeworks/homeworks-view.tsx';

// 学生的作业着陆页：列出已布置的作业及其提交状态。
// 教师的批改入口已收进课程（Coursework → Assignments），不再有独立跨课程页 →
// 教师访问此路径直接重定向到课程列表（父级 _learner 守卫已保证 user 非空且非 ADMIN）。
export const Route = createFileRoute('/_learner/homeworks')({
  beforeLoad: () => {
    const { user } = useAuth.getState();
    if (user?.role === 'TEACHER') throw redirect({ to: '/courses' });
  },
  component: HomeworksPage,
});

function HomeworksPage() {
  // 仅学生可达；null 仅为登出后的瞬态状态，因此渲染空而非崩溃。
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <HomeworksView />;
}
